/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostscolumncalls3Inputs */

const en_aicostscolumncalls3 = /** @type {(inputs: Aicostscolumncalls3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calls`)
};

const de_aicostscolumncalls3 = /** @type {(inputs: Aicostscolumncalls3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufrufe`)
};

/**
* | output |
* | --- |
* | "Calls" |
*
* @param {Aicostscolumncalls3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscolumncalls3 = /** @type {((inputs?: Aicostscolumncalls3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscolumncalls3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscolumncalls3(inputs)
	return de_aicostscolumncalls3(inputs)
});
export { aicostscolumncalls3 as "aiCostsColumnCalls" }